<template>
  <div class="myInfo_">
    <div style="padding: 10px 20px">随访工单完成进度统计</div>
    <el-table :data="tableData" style="width: 100%" height="500">
      <el-table-column
        fixed
        prop="user"
        label="名字"
        width="120"
        align="center"
      >
      </el-table-column>
      <el-table-column
        v-for="column in columnData"
        :label="column.label"
        :key="column.prop"
        align="center"
      >
        <el-table-column
          v-for="column_ in columnData_"
          :key="column_.prop"
          :prop="`${column.prop}.${column_.prop}`"
          :label="column_.label"
          width="100"
        >
        </el-table-column>
      </el-table-column>
    </el-table>
    <!-- <div style="padding: 10px 20px" v-if="powerVisit">随访工单完成进度统计</div>
    <div style="padding: 10px 20px" v-if="powerBill">发票审核完成进度统计</div>
    <div style="padding: 10px 20px" v-if="powerSick">注册审核完成进度统计</div> -->
    <div></div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
      columns: ["注册审核", "今天", "昨天", "本周", "本月", "全部"],
      dataList: [
        {
          name: "注册审核",
          columns: ["今天", "昨天", "本周", "本月", "全部"],
        },
      ],
      tableData: [],
      columnData: [
        // { label: "名字", prop: "patient_name" },
        { label: "当日", prop: "stat.today" },
        { label: "当月", prop: "stat.month" },
        { label: "全部", prop: "stat.all" },
        // { label: "已完成随访数", prop: "patient_data.tumour" },
        // { label: "未完成随访数", prop: "task_data.next_medication_date" },
        // { label: "已完成审核数", prop: "task_data.next_visit_date" },
        // { label: "未完成审核数", prop: "task_data.is_finish",},
        // { label: "已完成咨询问题数", prop: "task_data.finish_time" },
        // { label: "未完成咨询问题数", prop: "task_data.finish_time" },
      ],
      columnData_: [
        { label: "已完成随访数", prop: "visit_finished" },
        { label: "未完成随访数", prop: "visit_unfinished" },
        { label: "已完成审核数", prop: "audit_finished" },
        { label: "未完成审核数", prop: "audit_unfinished" },
        { label: "已完成咨询问题数", prop: "consult_finished" },
        { label: "未完成咨询问题数", prop: "consult_unfinished" },
      ],
    };
  },
  computed:{
    ...mapState('comInformationData', {
        authority: 'authority',
    }),
    authorityStr(){
      return this.authority.join(',');
    },
    powerSick() {
      return this.authorityStr.indexOf('sick-audit') > -1
    },
    powerBill() {
      return this.authorityStr.indexOf('bill-audit') > -1
    },
    powerVisit() {
      return this.authorityStr.indexOf('visit-audit') > -1
    },
  },
  methods: {
    getAllList() {
      this.httpGet("/visit_task/personal/stat").then((res) => {
        this.tableData = res.data;
      });
    },
  },
  mounted() {
    this.getAllList();
    console.log(this.powerSick,this.powerBill,this.powerVisit)
  },
};
</script>
<style lang="scss" scoped>

</style>
<style lang="scss">
.myInfo_{
  .el-table th.el-table__cell>.cell{
    font-size: 10px;
  }
}
</style>